<template>
  <div>
    <div v-show="success">
      <SuccessMessage @back="back()" />
    </div>
    <div v-if="loadingFinish">
      <Loading
        type="line"
        :center="false"
      />
      <AnimatedPhrase :phrases="['Aguarde...',
                'Isso pode levar alguns ou vários minutos...',
                'Estamos vinculando as tags...']" />
    </div>
    <div
      class="rfid-panel"
      v-if="!success && !loadingFinish"
    >
      <div class="rfid-title-row">
        <i class="fa-solid fa-tags title"></i>
        <span class="title">Produto</span>
      </div>
      <div class="rfid-search-row">
        <div
          class="rfid-search"
          @click="openSearchProducts()"
        >
          <i class="fa-solid fa-magnifying-glass"></i>
          <span class="rfid-title-search">Selecionar Produto</span>
        </div>
      </div>

      <div class="rfid-loading">
        <Loading
          type="line"
          :center="false"
          v-if="loading"
        />
      </div>
      <div
        v-if="selectedProduct && !loading"
        class="rfid-range-row"
      >

        <div class="rfid-field-large">
          <label>Nº Tag Inicial</label>
          <input
            v-model="rangeStart"
            placeholder="Ex: 000000000000001"
            type="text"
          />
        </div>

        <div class="rfid-field-large">
          <label>Nº Tag Final</label>
          <input
            v-model="rangeEnd"
            placeholder="Ex: 000000000000020"
            type="text"
            @keyup.enter="linkRange"
          />
        </div>

        <Button
          _key="btnLinked"
          type="info"
          :disabled="!rangeStart || !rangeEnd"
          title="Distribuir"
          classIcon="fa-solid fa-shuffle"
          size="medium"
          :clicked="linkRange"
        />

        <div class="rfid-btn-clean">
          <Button
            _key="btnClean"
            title="Limpar"
            :disabled="!rangeStart || !rangeEnd"
            type="info"
            classIcon="fa-sharp fa-solid fa-broom"
            size="medium"
            :clicked="clearRfids"
          />
        </div>
      </div>

      <div
        v-if="selectedProduct && !loading"
        class="rfid-mode-row"
      >
        <RadioGroup
          :formName="formName"
          field="group"
          :options="[
                    { text: 'Adicionar', value: 'add' },
                    { text: 'Atualizar', value: 'update' },
                ]"
          v-model="operationMode"
        />
      </div>

      <div
        v-if="mensagemErro"
        class="rfid-alert rfid-alert-danger"
      >
        {{ mensagemErro }}
      </div>

      <div
        v-if="mensagemSucesso"
        class="rfid-alert rfid-alert-success"
      >
        {{ mensagemSucesso }}
      </div>

      <div
        v-if="selectedProduct && !loading"
        class="rfid-product-info"
      >
        <div class="rfid-product-left title">
          <i class="fa-solid fa-layer-group rfid-product-icon"></i>
          <div>
            <div class="rfid-product-name">
              {{ selectedProduct.name }} - {{ selectedProduct.manufacturerName }}
            </div>
            <div class="rfid-product-sub">Patrimônios e Tags RFID</div>
          </div>
        </div>

        <div class="rfid-product-right">
          <div class="rfid-receive-tags">
            <ReceiveTags @process-tags="onReceiveTagsProcess" />
          </div>
          <span class="rfid-chip rfid-chip-gray">
            Total <b>{{ selectedProduct.patrimonies.length }}</b>
          </span>
          <span class="rfid-chip rfid-chip-green">
            Com RFID <b>{{ totalComRfid }}</b>
          </span>
          <span class="rfid-chip rfid-chip-yellow">
            Sem RFID <b>{{ totalSemRfid }}</b>
          </span>
        </div>
      </div>

      <ProductRfidLinkerList
        v-if="selectedProduct && !loading"
        :selectedProduct="selectedProduct"
        :operationMode="operationMode"
        :hasDuplicateError="hasDuplicateError"
        @finish="update"
      />
    </div>

    <Modal
      title="Selecionar Produto"
      :width="800"
      :height="750"
      v-if="showModal('searchProduct')"
    >
      <CheckboxServer
        title="Produtos"
        :showSearch="true"
        :multipleSelection="false"
        url="/api/v1/stock/patrimony/select-all-only-product"
        :changed="changed"
        v-model="selectedSearch"
      />
    </Modal>
  </div>
</template>

<script>
import AnimatedPhrase from "@nixweb/nixloc-ui/src/component/layout/AnimatedPhrase";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import CheckboxServer from "@nixweb/nixloc-ui/src/component/forms/CheckboxServer";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";

import ProductRfidLinkerList from "../linker-rfid/ProductRfidLinkerList.vue";
import ReceiveTags from "../receive/ReceiveTags.vue";
import SuccessMessage from "./SuccessMessage.vue";

import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "ProductRfidLinker",
  components: {
    AnimatedPhrase,
    Button,
    CheckboxServer,
    Modal,
    Loading,
    RadioGroup,
    Select,
    ProductRfidLinkerList,
    SuccessMessage,
    ReceiveTags,
  },
  data() {
    return {
      urlGetApi: "/api/v1/stock/patrimony/get-all-product-rfid-linker",
      urlUpdate: "/api/v1/stock/patrimony/update-product-rfid-linker",
      item: { typeProduct: {}, product: {} },
      products: [],
      selectedSearch: {},
      selectedProductId: null,
      rangeStart: "",
      rangeEnd: "",
      mensagemErro: "",
      mensagemSucesso: "",
      patrimonySeed: 5,
      loading: false,
      loadingFinish: false,
      success: false,
      operationMode: "add",
      hasDuplicateError: false,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    selectedProduct() {
      return this.products.find((p) => p.id === this.selectedProductId) || null;
    },
    totalComRfid() {
      return this.selectedProduct
        ? this.selectedProduct.patrimonies.filter((p) => p.rfid).length
        : 0;
    },
    totalSemRfid() {
      return this.selectedProduct
        ? this.selectedProduct.patrimonies.filter((p) => !p.rfid).length
        : 0;
    },
  },
  methods: {
    ...mapMutations("generic", [
      "openModal",
      "addEvent",
      "hideModal",
      "removeLoading",
    ]),
    ...mapActions("generic", ["getApi", "putApi"]),
    getAll() {
      this.loading = true;
      const params = {
        url: this.urlGetApi,
        obj: {
          any: this.selectedProductId,
        },
      };
      this.getApi(params).then((response) => {
        this.loading = false;
        this.products = response.content;
      });
    },
    hasDuplicateTags() {
      this.mensagemErro = "";
      this.hasDuplicateError = false;

      const prod = this.selectedProduct;
      if (!prod) return false;

      prod.patrimonies.forEach((p) => {
        p.hasDuplicateBarCode = false;
        p.hasDuplicateRfid = false;
      });

      const barCodeCount = {};
      const rfidCount = {};

      for (const pat of prod.patrimonies) {
        const bc = (pat.barCode || "").trim();
        const rf = (pat.rfid || "").trim();

        if (bc) {
          barCodeCount[bc] = (barCodeCount[bc] || 0) + 1;
        }
        if (rf) {
          rfidCount[rf] = (rfidCount[rf] || 0) + 1;
        }
      }

      let hasDuplicate = false;

      for (const pat of prod.patrimonies) {
        const bc = (pat.barCode || "").trim();
        const rf = (pat.rfid || "").trim();

        if (bc && barCodeCount[bc] > 1) {
          pat.hasDuplicateBarCode = true;
          hasDuplicate = true;
        }

        if (rf && rfidCount[rf] > 1) {
          pat.hasDuplicateRfid = true;
          hasDuplicate = true;
        }
      }

      if (hasDuplicate) {
        this.mensagemErro =
          "Existem patrimônios com Nº Patrimônio ou Tag RFID repetidos. Verifique as linhas destacadas em vermelho.";
        this.hasDuplicateError = true;
      }

      return hasDuplicate;
    },
    update() {
      this.clearMessages();

      if (this.hasDuplicateTags()) {
        this.removeLoading(["btnFinish"]);
        return;
      }

      this.loadingFinish = true;
      const params = {
        url: this.urlUpdate,
        obj: this.products,
        notNotifyToast: true,
      };
      this.putApi(params).then(() => {
        this.removeLoading(["btnFinish"]);
        const self = this;
        setTimeout(function () {
          self.loadingFinish = false;
          self.success = true;
        }, 3000);
      });
    },
    clearMessages() {
      this.mensagemErro = "";
      this.mensagemSucesso = "";
      this.hasDuplicateError = false;
    },
    clearRfids() {
      this.removeLoading(["btnLinked", "btnClean"]);
      this.operationMode = "add";
      this.clearMessages();

      this.rangeStart = "";
      this.rangeEnd = "";

      if (this.selectedProduct) {
        this.selectedProduct.patrimonies =
          this.selectedProduct.patrimonies.filter((p) => !p.isNew);
      }
    },
    linkRange() {
      this.clearMessages();
      const prod = this.selectedProduct;
      if (!prod) return;

      if (!this.rangeStart || !this.rangeEnd) {
        this.mensagemErro = "Informe Nº Tag RFID Inicial e Final.";
        this.removeLoading(["btnLinked"]);
        return;
      }

      const width = this.rangeStart.length;
      const start = parseInt(this.rangeStart, 10);
      const end = parseInt(this.rangeEnd, 10);

      if (isNaN(start) || isNaN(end)) {
        this.mensagemErro = "Faixa de tags inválida.";
        this.removeLoading(["btnLinked"]);
        return;
      }

      if (end < start) {
        this.mensagemErro = "Tag RFID Final deve ser maior que Inicial.";
        this.removeLoading(["btnLinked"]);
        return;
      }

      const totalTags = end - start + 1;

      if (this.operationMode === "add") {
        // ALTERAÇÃO: impedir duplicação de tags ao clicar várias vezes em "Distribuir"
        const existingRfids = new Set(
          prod.patrimonies
            .filter((p) => p.rfid)
            .map((p) => String(p.rfid).trim())
        );

        let hasAnyDuplicateInRange = false;
        for (let i = 0; i < totalTags; i++) {
          const tagCheck = String(start + i).padStart(width, "0");
          if (existingRfids.has(tagCheck)) {
            hasAnyDuplicateInRange = true;
            break;
          }
        }

        if (hasAnyDuplicateInRange) {
          this.mensagemErro =
            "Já existem patrimônios com uma ou mais Tags desta faixa. Ajuste a faixa ou use a opção Atualizar.";
          this.removeLoading(["btnLinked"]);
          return;
        }
        // FIM ALTERAÇÃO

        for (let i = 0; i < totalTags; i++) {
          const tag = String(start + i).padStart(width, "0");
          const tempId = `new-${this.patrimonySeed++}`;
          prod.patrimonies.push({
            id: null,
            tempId: tempId,
            barCode: `p-${tag}`,
            rfid: tag,
            editingBarCode: false,
            editingRfid: false,
            isNew: true,
          });
        }

        this.removeLoading(["btnLinked"]);
        this.mensagemSucesso = `Tags vinculadas: ${totalTags} novos patrimônios incluídos.`;
        return;
      }

      const patrimoniesSemRfid = prod.patrimonies.filter((p) => !p.rfid);
      const existentesSemRfid = patrimoniesSemRfid.length;
      const numPatrimoniesParaAtualizar = Math.min(
        totalTags,
        existentesSemRfid
      );

      if (numPatrimoniesParaAtualizar === 0) {
        this.mensagemErro =
          "Todos os patrimônios já possuem Tag preenchida ou a faixa de tags está vazia! Se for novas Tags marque a opção Adicionar!";
        this.removeLoading(["btnLinked"]);
        return;
      }

      let updated = 0;

      for (let i = 0; i < numPatrimoniesParaAtualizar; i++) {
        const tag = String(start + i).padStart(width, "0");
        patrimoniesSemRfid[i].rfid = tag;
        updated++;
      }

      const tagsNaoUsadas = totalTags - updated;
      const mensagemTagsNaoUsadas =
        tagsNaoUsadas > 0 ? ` (${tagsNaoUsadas} tags não utilizadas).` : "";

      this.removeLoading(["btnLinked"]);
      this.mensagemSucesso = `Tags Vinculadas: ${updated} patrimônios sem RFID atualizados.${mensagemTagsNaoUsadas}`;
    },
    onReceiveTagsProcess(payload) {
      const rawTags = Array.isArray(payload && payload.tags) ? payload.tags : [];
      const tags = rawTags
        .map((item) => (typeof item === "string" ? item : item && item.tag))
        .map((tag) => String(tag || "").trim())
        .filter((tag) => !!tag);

      this.clearMessages();

      const prod = this.selectedProduct;
      tags.forEach((tag) => {
        const tempId = `new-${this.patrimonySeed++}`;
        prod.patrimonies.push({
          id: null,
          tempId,
          barCode: `p-${tag}`,
          rfid: tag,
          editingBarCode: false,
          editingRfid: false,
          isNew: true,
        });
      });

      this.mensagemSucesso = `Total de ${tags.length} tags importadas.`;
    },
    openSearchProducts() {
      this.openModal("searchProduct");
      this.addEvent({ name: "cleanCheckboxServer" });
    },
    changed(value) {
      this.selectedProductId = value;
      this.getAll();
      this.hideModal();
    },
    back() {
      this.operationMode = "add";
      this.success = false;
      this.clearRfids();
    },
  },
};
</script>

<style scoped>
.rfid-panel {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
  background: #fff;
}

.rfid-title-row {
  padding: 14px 18px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #eef0f3;
  color: #374151;
}

.rfid-search-row {
  padding: 18px;
}

.rfid-range-row {
  padding: 0 18px 8px 18px;
  display: flex;
  gap: 16px;
  align-items: flex-end;
}

.rfid-mode-row {
  padding: 0 18px 14px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #4b5563;
}

.rfid-field-large label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  display: block;
}

.rfid-field-large input {
  padding: 4px 10px;
  width: 300px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
}

.rfid-loading {
  margin: 5px 5px 10px 5px;
}

.rfid-search {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 12px;
  border-radius: 999px;
  background: #f8fafc;
  color: #1e293b;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #e1e1e2;
  box-shadow: 0 0 0 1px #f8fafc inset;
}

.rfid-btn-clean {
  margin-left: -12px;
}

.rfid-alert {
  padding: 12px 18px;
  font-size: 15px;
}

.rfid-alert-danger {
  background: #fee2e2;
  color: #b91c1c;
}

.rfid-alert-success {
  background: #dcfce7;
  color: #15803d;
}

.rfid-product-info {
  padding: 16px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  border-bottom: 1px solid #eef0f3;
}

.rfid-product-left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.rfid-product-name {
  font-size: 17px;
  font-weight: 600;
}

.rfid-product-sub {
  font-size: 14px;
  color: #6b7280;
}

.rfid-product-right {
  display: flex;
  gap: 6px;
  align-items: center;
}

.rfid-receive-tags {
  display: flex;
  align-items: center;
}

.rfid-title-search {
  margin-left: 5px;
}

.rfid-chip {
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 13px;
}

.rfid-div-check-sem-rfid {
  margin-left: 10px;
}

.rfid-chip-gray {
  background: #e5e7eb;
  color: #374151;
}

.rfid-chip-green {
  background: #bbf7d0;
  color: #166534;
}

.rfid-chip-yellow {
  background: #fde68a;
  color: #92400e;
}
</style>
